<template>
  <div ref="c_actions" class="c-actions">
    <div class="actions-cell">
      <div :id="anchorId" class="actions-wrapper" @click.stop="toggleAction(item.id)">
        <img :src="imgAction" alt="Actions" />
      </div>
      <div v-show="opened" :id="popupId" class="action-select">
        <div v-for="(action, index) in actions" :key="index">
          <slot
            v-if="action.able ? $app.auth.can(action.able) : true"
            :name="action.name" :action-item="item" :index="index" :act="action">
            <div class="action-item" @click.stop="handleAction(action, item)">
              <img :src="action.image" alt="" />
              <span>{{ action.title }}</span>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import imgAction from '../../assets/new/action-icon.svg'
export default {
  name: 'CAttachRole',
  props: {
    actions: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgAction,
      opened: false,
      popupId: Math.random()+'popup',
      anchorId: Math.random()+'anchor',
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        setTimeout(() => {
          this.updatePosition()
        }, 0.01)
        this.opened = this.isOpen
      } else {
        this.opened = this.isOpen
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const popup = this.$refs.c_actions
      if (popup && !popup.contains(event.target)) {
        this.$emit('opened', null)
      }
    },
    updatePosition() {
      const anchor = document.getElementById(this.anchorId)
      const popup = document.getElementById(this.popupId)
      const rect = anchor.getBoundingClientRect()
      const zoom = rect.width / anchor.offsetWidth
      const zoomScale = (1 - zoom) > 0 ? 1 - zoom + 0.025 : 0

      const popupWidth = popup.offsetWidth
      const popupHeight = popup.offsetHeight

      const spaceBelow = window.innerHeight - rect.bottom
      const spaceAbove = rect.top

      // если места снизу нет, рисуем над якорем
      if (spaceBelow < popupHeight && spaceAbove > spaceBelow) {
        popup.style.top = (rect.top + rect.top * zoomScale) - popupHeight + 'px'
      } else {
        popup.style.top = (rect.bottom + rect.bottom * zoomScale) + 'px'
      }

      // позиция по горизонтали (правый край попапа совпадает с левым краем якоря)
      popup.style.left = (rect.left + rect.left * zoomScale) - popupWidth + 'px'

      setTimeout(() => {
        popup.style.display = 'block'
      }, 0.1)
    },
    handleAction(action, item) {
      this.$emit(action.name, item)
      this.$emit('opened', null)
    },
    toggleAction(id) {
      if (this.opened) {
        id = null
      }
      this.$emit('opened', id)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-actions {
  .shadow {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 9;
  }
  .actions-cell {
    position: relative;
    .actions-wrapper {
      cursor: pointer;
      padding: 4px;
      display: inline-flex;
    }
    .action-select {
      position: fixed;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
      width: 160px;
      z-index: 9;
      overflow: hidden;
      &.hidden {
        visibility: hidden;
      }

      .action-item {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        cursor: pointer;
        transition: background-color 0.2s;
        border-bottom: 1px solid #E7EDFF;
        img {
          width: 16px;
          margin-right: 10px;
        }
        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }
}
</style>
